// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestAttributeLineageId } from './HarvestAttributeLineage';
import { z } from 'zod';
export const harvestTabularColumnLineageId = (z.string());
export const harvestTabularColumnLineage = z.object({
    id: harvestTabularColumnLineageId,
    attribute_lineage_id: harvestAttributeLineageId,
    created_at: z.date(),
});
export const harvestTabularColumnLineageInitializer = z.object({
    id: harvestTabularColumnLineageId.optional(),
    attribute_lineage_id: harvestAttributeLineageId,
    created_at: z.date().optional(),
});
export const harvestTabularColumnLineageMutator = z.object({
    id: harvestTabularColumnLineageId.optional(),
    attribute_lineage_id: harvestAttributeLineageId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=HarvestTabularColumnLineage.js.map